import { render } from "./uploadZBGZList.vue?vue&type=template&id=39f5f11a&scoped=true"
import script from "./uploadZBGZList.vue?vue&type=script&lang=js"
export * from "./uploadZBGZList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f5f11a"]])

export default __exports__